
// Specify the base path for all assets within the application
// FIXME: set publicPath statically in webpack.config with an env var instead of assigning the path at runtime.
if (window && window._static_url) { // eslint-disable-line no-undef
  __webpack_public_path__ = window._static_url; // eslint-disable-line no-undef
}
